module.exports = __webpack_public_path__ + "static/media/logo-asia.835a24c3.png";